(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3073],{

/***/ 58941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94007);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);



var Grid = function Grid(props) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, { mx: "-10px", my: "-10px", flexWrap: "wrap", children:
      props.iterableItems.map(function (item, index) {return /*#__PURE__*/(
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, { width: [1, 1, 1 / props.col], px: "10px", my: "10px", children:
            props.children(item) }, index));}) }));};





/* harmony default export */ __webpack_exports__["Z"] = (Grid);

/***/ }),

/***/ 47442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var _components_buttons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49613);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94007);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85169);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
var _excluded = ["data-testid"]; // flow




var LoadMoreSection = function LoadMoreSection(_ref)


{var _props$data, _props$data2, _props$data3;var _ref$dataTestid = _ref['data-testid'],dataTestId = _ref$dataTestid === void 0 ? 'LoadMoreSection' : _ref$dataTestid,props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);
  return ((_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.totalCount) / ((_props$data2 = props.data) === null || _props$data2 === void 0 ? void 0 : _props$data2.perPage) > ((_props$data3 = props.data) === null || _props$data3 === void 0 ? void 0 : _props$data3.page) ? /*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, { mb: "20px", mt: "20px", justifyContent: "center", children: /*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP, {
      appearance: "outline",
      loading: props.loading,
      onClick: props.onLoadMoreClick,
      spinnerColor: "#7d7d7d", children: /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_4__/* .Trans */ .cC, { id: "metadata.show_more", message: "Show more" }) }) }) :


  null;
};

/* harmony default export */ __webpack_exports__["Z"] = (LoadMoreSection);

/***/ }),

/***/ 9128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);

















var MetaTags = function MetaTags(props) {var _props$description, _props$description2;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();

  var thumbnail = "https://devenv.yogobe.com" + '/static/opengraph.png';
  if (props.thumbnailUrl) {var _props$thumbnailUrl, _props$thumbnailUrl2;
    if (
    (_props$thumbnailUrl = props.thumbnailUrl) !== null && _props$thumbnailUrl !== void 0 && _props$thumbnailUrl.startsWith('http') || (_props$thumbnailUrl2 =
    props.thumbnailUrl) !== null && _props$thumbnailUrl2 !== void 0 && _props$thumbnailUrl2.startsWith('//'))
    {
      thumbnail = props.thumbnailUrl;
    } else {
      thumbnail = "https://devenv.yogobe.com" + props.thumbnailUrl;
    }
  }

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("title", { children: props.title + ' - Yogobe' }),
      props.description ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { name: "description", content: props.description }) :
      null, /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:url", content: "https://devenv.yogobe.com" + router.asPath }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:type", content: "article" }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:title", content: props.title + ' - Yogobe' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:description", content: (_props$description = props.description) !== null && _props$description !== void 0 ? _props$description : '' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "og:image", content: thumbnail }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "fb:app_id", content: "313516218776996" }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", {
        property: "twitter:title",
        content: "Yoga och tr\xE4ning online f\xF6r h\xE5llbar h\xE4lsa | YOGOBE - Yogobe" }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:title", content: props.title + ' - Yogobe' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:card", content: (_props$description2 = props.description) !== null && _props$description2 !== void 0 ? _props$description2 : '' }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:site", content: "https://devenv.yogobe.com" }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:image", content: thumbnail }), /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "twitter:creator", content: "Yogobe" }),
      props.brand && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:brand", content: props.brand }),


      props.availability && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:availability", content: props.availability }),


      props.condition && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:condition", content: props.condition }),


      typeof props.price === 'number' && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:price:amount", content: props.price }),


      props.currency && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:price:currency", content: props.currency }),


      props.retailerId && /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("meta", { property: "product:retailer_item_id", content: props.retailerId })] }));



};

/* harmony default export */ __webpack_exports__["Z"] = (MetaTags);

/***/ }),

/***/ 70300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var _components_texts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45945);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}




var Header = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(_components_texts__WEBPACK_IMPORTED_MODULE_3__/* .H2SectionHeader */ .L0).withConfig({ displayName: "SectionHeader__Header", componentId: "sc-j2xtiu-0" })(["", ""],
_components_texts__WEBPACK_IMPORTED_MODULE_3__/* .sectionTitleStyle */ .d1);











var SectionHeader = function SectionHeader(props) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, { children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
        className: props.className,
        justifyContent: "space-between",
        alignItems: "center", children: [/*#__PURE__*/

        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { children: [/*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Header, { className: "SectionHeader--H2SectionHeader", children:
            props.title }),

          props.subTitle && /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_3__/* .SubTitle */ .DK, _objectSpread(_objectSpread({},
          props.subTitleStyle ?
          { customStyle: props.subTitleStyle } :
          {}), {}, { children:

            props.subTitle })),


          props.secondSubtitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_3__/* .SubTitle */ .DK, { children: props.secondSubtitle })] }),

        props.button ? /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { flexShrink: 0, ml: [40, 40, 0], children:
          props.button }) :

        null] }) }));};




/* harmony default export */ __webpack_exports__["Z"] = (SectionHeader);

/***/ }),

/***/ 94997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ Image; },
/* harmony export */   "Xd": function() { return /* binding */ BackgroundImage; }
/* harmony export */ });
/* unused harmony export Ratio */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
var _excluded = ["className", "objectFit"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}


var Image = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].img.withConfig({ displayName: "ThumbnailWithRatio__Image", componentId: "sc-pg90bj-0" })(["position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;"]);








var Ratio = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({ displayName: "ThumbnailWithRatio__Ratio", componentId: "sc-pg90bj-1" })(["position:relative;padding-top:", ";"],

function (props) {return props.ratio ? props.ratio : '56.25%';});


var BackgroundImage = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({ displayName: "ThumbnailWithRatio__BackgroundImage", componentId: "sc-pg90bj-2" })(["width:100%;height:auto;position:absolute;top:0;left:0;bottom:0;right:0;background-size:cover;background-position:center;width:100%;height:100%;box-shadow:", ";", ";", ";", ";"],












function (props) {return (
    props.shadow && "inset 0px -112px 68px -64px rgba(0,0,0,0.75)");},
function (props) {return (
    props.withRadius && (
    props.large ? "\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0;\n          border-top-left-radius: 5px;\n          border-bottom-left-radius: 5px;\n          @media (max-width: ".concat(





    props.theme.viewports.mobile, "px) {\n            border-bottom-right-radius: 0;\n            border-bottom-left-radius: 0;\n            border-top-left-radius: 5px;\n            border-top-right-radius: 5px;\n          }\n        ") : "\n          border-bottom-right-radius: 0;\n          border-bottom-left-radius: 0;\n          border-top-left-radius: 5px;\n          border-top-right-radius: 5px;\n        "));},












function (props) {return (
    props.isProgram ? "\n          border-radius: 3px;\n        " :



    null);},
function (props) {return (
    props.isLocked ? "\n          overflow: hidden;\n          &:before {\n            content: '';\n            position: absolute;\n            top: 0;\n            left: 0;\n            right: 0;\n            bottom: 0;\n            opacity: 0.8;\n            background-color: #9dc9c7;\n          }\n          &:after {\n            font-family: 'ygb-font' !important;\n            speak: none;\n            font-style: normal;\n            font-weight: normal;\n            font-variant: normal;\n            text-transform: none;\n            z-index: 1;\n            /* Better Font Rendering =========== */\n            -webkit-font-smoothing: antialiased;\n            -moz-osx-font-smoothing: grayscale;\n            content: '\\e94b';\n            height: 24px;\n            width: 24px;\n            color: white;\n            position: absolute;\n            top: calc(50% - 12px);\n            left: calc(50% - 12px);\n            text-align: center;\n            line-height: 24px;\n          }\n        " :


































    null);});


var PLACEHOLDER_IMAGE =
'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPcWw8AAf8BPlp9PLwAAAAASUVORK5CYII=';

var ThumbnailWithRatio = function ThumbnailWithRatio(_ref)



{var _ref$className = _ref.className,className = _ref$className === void 0 ? null : _ref$className,_ref$objectFit = _ref.objectFit,objectFit = _ref$objectFit === void 0 ? 'cover' : _ref$objectFit,props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(Ratio, { className: className, ratio: props.ratio, children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Image, {
        src: props.path || PLACEHOLDER_IMAGE,
        objectFit: objectFit,
        loading: "lazy" }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(BackgroundImage, _objectSpread(_objectSpread(_objectSpread({},
      props),
      props.isLocked ? { 'data-locked': true } : {}), {}, { children:

        props.children }))] }));



};

ThumbnailWithRatio.toString = Ratio.toString;

/* harmony default export */ __webpack_exports__["ZP"] = (ThumbnailWithRatio);

/***/ }),

/***/ 43012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QB": function() { return /* binding */ items6; },
/* harmony export */   "dz": function() { return /* binding */ items10; },
/* harmony export */   "gE": function() { return /* binding */ items2; },
/* harmony export */   "l6": function() { return /* binding */ items5; },
/* harmony export */   "u7": function() { return /* binding */ items3; }
/* harmony export */ });
/* unused harmony exports items8, items4, taxonomies, CollectionCardMeta, CourseCardMeta, PlaylistCardMeta, VideoCardMeta, BlogItemCardMeta, RelatedVideoMeta, InstructorMeta, ResultArticleMeta, ResultUserMeta, ResultPositionMeta */
var items10 = Array.from(Array(10).keys());
var items8 = Array.from(Array(8).keys());
var items6 = Array.from(Array(6).keys());
var items5 = Array.from(Array(5).keys());
var items4 = Array.from(Array(4).keys());
var items3 = Array.from(Array(3).keys());
var items2 = Array.from(Array(2).keys());

var taxonomies = [
{
  name: 'Styles',
  open: false,
  terms: [
  { name: 'Hatha', important: true, selected: false },
  { name: 'Yin yoga', important: true, selected: false },
  { name: 'Partner yoga', selected: false },
  { name: 'Student yoga', selected: false },
  { name: 'Yoyo yoga', selected: false },
  { name: 'Something yoga', selected: false },
  { name: 'Bla yoga', selected: false },
  { name: 'Work yoga', selected: false },
  { name: 'Royce yoga', selected: false },
  { name: 'Marshall yoga', selected: false },
  { name: 'Twitter yoga', selected: false },
  { name: 'Fb yoga', selected: false },
  { name: 'Ko yoga', selected: false },
  { name: 'Lo yoga', selected: false },
  { name: 'Po yoga', selected: false },
  { name: 'Yaou yoga', selected: false }] },


{
  name: 'Duration',
  open: false,
  terms: [
  { name: '5 minutes', selected: false },
  { name: '15 minutes', selected: false }] },


{
  name: 'Something',
  open: false,
  terms: [{ name: 'Test', selected: false }] },

{
  name: 'Something 2',
  open: false,
  terms: [{ name: 'Test again', selected: false }] },

{
  name: 'Something 3',
  open: false,
  terms: [{ name: 'Test again again', selected: false }] }];



var CollectionCardMeta = {
  name: 'For athletes',
  thumbnailUrl: 'http://via.placeholder.com/300x295' };


var CourseCardMeta = {
  title: 'Fall asleep - Yoga Nidra',
  secondTitle: 'YOMI Yin online',
  description:
  'Kom ner i varv och hjälp kroppen att somna gott. de förberedande positionerna hjälper dig komma ner i varv och hitta in i kroppen innan du guidas in i yoga nidra, yogisk sömn, för total avslappning',
  thumbnailUrl: 'http://via.placeholder.com/500x500' };


var PlaylistCardMeta = {
  title: 'Fall asleep - Yoga Nidra',
  description:
  'Kom ner i varv och hjälp kroppen att somna gott. de förberedande positionerna hjälper dig komma ner i varv och hitta in i kroppen innan du guidas in i yoga nidra, yogisk sömn, för total avslappning',
  thumbnailUrl: 'http://via.placeholder.com/500x500',
  duration: 30,
  videoCount: 2,
  createdBy: 'Yogobe' };


var VideoCardMeta = {
  title: 'Yogalärartips: Passning i hunden för nybörjare',
  description:
  'Ett bra ställe att börja hela om vi kommit ur balans är hur viförhåller oss till oss själva',
  duration: 5,
  favorite: false,
  instructorName: 'Johanna Alvin',
  genre: 'Yin',
  thumbnailUrl: 'http://via.placeholder.com/500x500',
  videoSlug: '/test1',
  instructorSlug: '/instructor1',
  genreSlug: '/genre1' };


var BlogItemCardMeta = {
  title: '12 veckor till milen',
  description:
  'Kom igång med din löpträning! Magnus Hagström guidar dig mot målet att kunna springa 1 mil om 12 veckor. Ett program för alla som vill bygga upp en hållbar löpträning!',
  thumbnailUrl: 'http://via.placeholder.com/500x500',
  blogUrl: '' };


var RelatedVideoMeta = {
  name: 'Teknik asana: Eka Pada Galavasana / Fly lol hi something else?',
  description: 'Teknik för armbalans som stärker armar, axlar & core',
  thumbnailUrl: 'http://via.placeholder.com/500x500',
  videoUrl: '/test',
  duration: 5 };


var InstructorMeta = {
  firstName: 'Johanna',
  lastName: 'Alvin',
  description:
  'Johanna är i grunden idrottslärare och har de flesta instruktörsutbildningar inom gymvärlden i ryggen. Numera jobbar hon dock med yoga på heltid. Hon driver studion FLOW i Göteborg, jobbar med PT-kunder, håller workshops, kurser ...',
  thumbnailUrl: 'http://via.placeholder.com/60x60',
  instructorUrl: '/test' };


var ResultArticleMeta = {
  thumbnailUrl: 'http://via.placeholder.com/300x295',
  title: 'Ärtpesto – familjens nya middagsfavorit' };


var ResultUserMeta = {
  thumbnailUrl: 'http://via.placeholder.com/300x295',
  name: 'Dianne Ameter' };


var ResultPositionMeta = {
  thumbnailUrl: 'http://via.placeholder.com/300x295',
  title: 'Title',
  english_title: 'English title',
  local_language_title: 'local_language_title' };

/***/ }),

/***/ 37301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SZ": function() { return /* reexport safe */ _components_texts__WEBPACK_IMPORTED_MODULE_4__.SZ; },
/* harmony export */   "__": function() { return /* reexport safe */ _components_form_Label__WEBPACK_IMPORTED_MODULE_1__.Z; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31157);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85169);
/* harmony import */ var _components_form_Label__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25077);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var _components_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4338);
/* harmony import */ var _components_texts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45945);
/* harmony import */ var _components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94997);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);









var Card = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({ displayName: "BlogItemCard__Card", componentId: "sc-zble3p-0" })(["border-radius:5px;cursor:pointer;text-decoration:none;", "{object-fit:contain;}"],




_components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_5__/* .Image */ .Ee);




var BlogItemCard = function BlogItemCard(props) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(Card, { className: props.className, children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mb: 20, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { href: props.redirectUrl, children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, { path: props.thumbnailUrl, objectFit: "contain" }) }) }), /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mb: 10, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_form_Label__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { children: props.title }) }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        mb: "10px",
        style:
        props.noTrancate ?
        {} :
        {
          height: '38px' }, children: /*#__PURE__*/



        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardDescription */ .SZ, {
          dangerouslySetInnerHTML: {
            __html: props.description.substr(0, 300).replace(/<img[^>]*>/g, '') } }) }), /*#__PURE__*/



      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { className: "ReadMore--btn", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { href: props.redirectUrl, bold: true, children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_8__/* .Trans */ .cC, { id: "metadata.read_more", message: 'Read more' }) }) })] }));




};


/* harmony default export */ __webpack_exports__["ZP"] = (BlogItemCard);

/***/ }),

/***/ 18506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _default; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(92777);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(82262);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(10748);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(81531);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37247);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(90116);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(71383);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _apollo_client_react_components__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(72939);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(12922);
/* harmony import */ var _components_Grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58941);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94007);
/* harmony import */ var _components_LoadMoreSection__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47442);
/* harmony import */ var _components_MetaTags__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9128);
/* harmony import */ var _components_SectionHeader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70300);
/* harmony import */ var _lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17516);
/* harmony import */ var _lib_faker__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43012);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(85169);
/* harmony import */ var _organisms_cards_BlogItemCard__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(37301);
/* harmony import */ var _skeletons_BlogCardSkeleton__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10759);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(85893);
var _templateObject;function _createSuper(Derived) {var hasNativeReflectConstruct = _isNativeReflectConstruct();return function _createSuperInternal() {var Super = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Derived),result;if (hasNativeReflectConstruct) {var NewTarget = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this).constructor;result = Reflect.construct(Super, arguments, NewTarget);} else {result = Super.apply(this, arguments);}return (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result);};}function _isNativeReflectConstruct() {if (typeof Reflect === "undefined" || !Reflect.construct) return false;if (Reflect.construct.sham) return false;if (typeof Proxy === "function") return true;try {Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));return true;} catch (e) {return false;}}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}













var GET_POSTS = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(["\n  query posts($page: Int, $perPage: Int) {\n    posts(page: $page, perPage: $perPage) {\n      page\n      perPage\n      totalCount\n      data {\n        id\n        title\n        featuredImage\n        body\n        slug\n      }\n    }\n  }\n"])));
















var updatePostsQuery = function updatePostsQuery(prev, _ref) {var fetchMoreResult = _ref.fetchMoreResult;
  if (!fetchMoreResult) return prev;
  return Object.assign({}, prev, {
    posts: _objectSpread(_objectSpread({},
    fetchMoreResult.posts), {}, {
      data: [].concat((0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(prev.posts.data), (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(fetchMoreResult.posts.data)) }) });


};var _default = /*#__PURE__*/function (_Component) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_default, _Component);var _super = _createSuper(_default);function _default() {var _this;(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(this, _default);for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}_this = _super.call.apply(_super, [this].concat(args));(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_this), "state",


    {
      fetchingMore: false });return _this;}(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_default, [{ key: "render", value:


    function render() {var _this2 = this;
      return /*#__PURE__*/(
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, { children: /*#__PURE__*/


          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__/* .Container */ .W2, { flexDirection: 'column', my: "50px", px: [25, 25, 10], children: [/*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_components_MetaTags__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
              title: {
                id: 'opengraph.blog_title',
                defaults: 'Blog Title' },

              description: {
                id: 'opengraph.blog_description',
                defaults: 'Blog Description' } }), /*#__PURE__*/



            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, { mb: "20px", children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_components_SectionHeader__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, { title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_21__/* .Trans */ .cC, { id: "blog.title", message: 'Blog' }) }) }), /*#__PURE__*/


            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_apollo_client_react_components__WEBPACK_IMPORTED_MODULE_22__/* .Query */ .A, { query: GET_POSTS, variables: { perPage: 3 }, children:
              function children(_ref2) {var error = _ref2.error,loading = _ref2.loading,data = _ref2.data,fetchMore = _ref2.fetchMore;
                if (error) return null;
                if (loading) {
                  return /*#__PURE__*/(
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_components_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { iterableItems: _lib_faker__WEBPACK_IMPORTED_MODULE_10__/* .items3 */ .u7, col: 3, children:
                      function children() {return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_skeletons_BlogCardSkeleton__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {});} }));


                }
                var posts = data.posts;
                return /*#__PURE__*/(
                  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, { children: [/*#__PURE__*/
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Consumer */ .Z.Consumer, { children:
                      function children(locale) {return /*#__PURE__*/(
                          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_components_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { iterableItems: posts.data, col: 3, children:
                            function children(item) {return /*#__PURE__*/(
                                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_organisms_cards_BlogItemCard__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                  title: item.title,
                                  description: item.body.substring(0, 200),
                                  thumbnailUrl: item.featuredImage,
                                  redirectUrl: "/".concat(locale, "/blog/").concat(item.slug) }));} }));} }), /*#__PURE__*/






                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_components_LoadMoreSection__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                      data: posts,
                      loading: _this2.state.fetchingMore,
                      onLoadMoreClick: function onLoadMoreClick() {
                        _this2.setState({ fetchingMore: true });
                        fetchMore({
                          variables: {
                            page: posts.page + 1 },

                          updateQuery: updatePostsQuery }).
                        then(function () {
                          _this2.setState({ fetchingMore: false });
                        });
                      } })] }));



              } })] }) }));




    } }]);return _default;}(react__WEBPACK_IMPORTED_MODULE_3__.Component);

/***/ }),

/***/ 10759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94007);
/* harmony import */ var _BaseSkeleton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30794);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);




var BlogCardSkeleton = function BlogCardSkeleton(props) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
        pb: '56.25%',
        height: 0,
        as: _BaseSkeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
        mb: "30px",
        animation: props.animation }), /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_BaseSkeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        height: 10,
        width: 100,
        marginBottom: 20,
        animation: props.animation }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_BaseSkeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        height: 10,
        width: 100,
        marginBottom: 20,
        animation: props.animation }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_BaseSkeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        height: 10,
        width: 60,
        marginBottom: 20,
        animation: props.animation })] }));};




/* harmony default export */ __webpack_exports__["Z"] = (BlogCardSkeleton);

/***/ }),

/***/ 54994:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/blog",
      function () {
        return __webpack_require__(18506);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72939:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Query; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70655);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var _hooks_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37887);



function Query(props) {
    var children = props.children, query = props.query, options = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__rest */ ._T)(props, ["children", "query"]);
    var result = (0,_hooks_index_js__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(query, options);
    return result ? children(result) : null;
}
Query.propTypes = {
    client: prop_types__WEBPACK_IMPORTED_MODULE_2__.object,
    children: prop_types__WEBPACK_IMPORTED_MODULE_2__.func.isRequired,
    fetchPolicy: prop_types__WEBPACK_IMPORTED_MODULE_2__.string,
    notifyOnNetworkStatusChange: prop_types__WEBPACK_IMPORTED_MODULE_2__.bool,
    onCompleted: prop_types__WEBPACK_IMPORTED_MODULE_2__.func,
    onError: prop_types__WEBPACK_IMPORTED_MODULE_2__.func,
    pollInterval: prop_types__WEBPACK_IMPORTED_MODULE_2__.number,
    query: prop_types__WEBPACK_IMPORTED_MODULE_2__.object.isRequired,
    variables: prop_types__WEBPACK_IMPORTED_MODULE_2__.object,
    ssr: prop_types__WEBPACK_IMPORTED_MODULE_2__.bool,
    partialRefetch: prop_types__WEBPACK_IMPORTED_MODULE_2__.bool,
    returnPartialData: prop_types__WEBPACK_IMPORTED_MODULE_2__.bool
};
//# sourceMappingURL=Query.js.map

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(54994); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);